import ComScore from './ComScore.js';
import ATInternetDevelopers from './ATInternetDevelopers.js';
import MUX from './MUX.js';

// eslint
/* global cast */

export default class Analytics {
    /**
     * Initialize each analytic defined in the data
     * @param {Object|Array} data analytic settings data
     */
    constructor(data, logger, collectDomain, collectDomainSSL) {
        this.context = cast.framework.CastReceiverContext.getInstance();
        this.playerManager = this.context.getPlayerManager();
        this.logger = logger;
        this.collectDomain = collectDomain;
        this.collectDomainSSL = collectDomainSSL;
        this.analytics = [];

        this.init(data);
    }

    init(data) {
        let analyticsData = [];
        if (!(data instanceof Array)) {
            analyticsData.push(data);
        } else {
            analyticsData = data;
        }

        if (analyticsData instanceof Array) {
            this.logger.info('Initialize Analytics Array');
            const analyticsLength = analyticsData.length;
            for (let i = 0; i < analyticsLength; i += 1) {
                const analyticsItem = analyticsData[i];
                this.logger.info(analyticsItem);
                this.logger.info(`Initialize Analytics ${analyticsItem.type}`);
                this.analytics[i] = this.startAnalytics(
                    analyticsItem.type,
                    analyticsItem.options
                );
                if (this.analytics[i]) {
                    this.analytics[i].initEvents();
                }
            }
        }
    }

    /**
     * @param {string} type
     * @param {Object} options
     */
    startAnalytics(type, options) {
        this.logger.info(`Start Analytic for type: ${type}`);

        switch (type) {
        case 'comscore':
            return new ComScore(options, this.logger);
        case 'atinternetdevelopers':
            return new ATInternetDevelopers(options, this.logger, this.collectDomain, this.collectDomainSSL);
        case 'mux':
            return new MUX(options, this.logger);
        default:
            this.logger.warning(`Start for analytic ${type} not supported`);
            return null;
        }
    }

    /**
     * Set custom data for each analytic
     * @param {*} customData
     */
    setCustomData(customData) {
        const analyticsLength = this.analytics.length;
        for (let i = 0; i < analyticsLength; i += 1) {
            this.analytics[i].setCustomData(customData);
        }
    }
}
